import { createContext } from "react";
import { ProgramDetails } from "../../services/program.service";

export interface ProgramContextType {
  activePrograms: ProgramDetails[];
  isLoading: boolean;
  error: string | null;
  fetchPrograms: () => Promise<void>;
}

export const ProgramContext = createContext<ProgramContextType | undefined>(
  undefined
);
